import React from 'react';
import { TopNavbar } from '../../components/Navigation/TopNavbar';

const TopNavDemo: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Top Navigation */}
      <TopNavbar />

      {/* Demo Content */}
      <main className="p-6 bg-background-secondary min-h-screen">
        <div className="max-w-7xl mx-auto">
          <div className="bg-white rounded-lg shadow-card p-8 mb-6">
            <h1 className="text-4xl font-bold text-text-primary mb-4">
              Nuevo Diseño de Menú Superior
            </h1>
            <p className="text-text-secondary text-lg mb-6">
              El menú lateral ha sido transformado en un menú superior horizontal que permite expandir la visión del contenido.
            </p>

            <div className="space-y-4">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
                <h2 className="text-2xl font-semibold text-blue-900 mb-3">✨ Características Principales</h2>
                <ul className="space-y-2 text-blue-800">
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Menú superior horizontal con el mismo esquema de colores del menú lateral (gradiente azul oscuro)</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Dropdown funcional para "Área Deportiva" con todas las sub-opciones</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Mayor espacio disponible para el contenido (sin offset lateral)</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Logo ScoutMind visible en el menú superior</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Selector de idioma con icono de globo</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Menú de usuario con información del perfil y logout</span>
                  </li>
                </ul>
              </div>

              <div className="bg-green-50 border border-green-200 rounded-lg p-6">
                <h2 className="text-2xl font-semibold text-green-900 mb-3">🎨 Diseño y Colores</h2>
                <p className="text-green-800 mb-3">
                  Se mantienen los colores originales del menú lateral:
                </p>
                <ul className="space-y-2 text-green-800">
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Fondo: gradient-sidebar-menu (negro a #0F2A7D a #12182E)</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Texto: blanco con opacidad 80%</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Hover: fondo blanco con 10% de opacidad</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Activo: fondo blanco con 20% de opacidad y sombra</span>
                  </li>
                </ul>
              </div>

              <div className="bg-purple-50 border border-purple-200 rounded-lg p-6">
                <h2 className="text-2xl font-semibold text-purple-900 mb-3">📱 Funcionalidad</h2>
                <ul className="space-y-2 text-purple-800">
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Dropdowns se cierran al hacer clic fuera</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Iconos animados (rotación del chevron al abrir)</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Transiciones suaves en todas las interacciones</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Navegación completamente funcional</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Sample cards to show the expanded content area */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white rounded-lg shadow-card p-6">
              <h3 className="text-xl font-semibold text-text-primary mb-2">Más Espacio</h3>
              <p className="text-text-secondary">
                El contenido ahora tiene acceso a todo el ancho de la pantalla, sin el espacio ocupado por el menú lateral.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-card p-6">
              <h3 className="text-xl font-semibold text-text-primary mb-2">Diseño Moderno</h3>
              <p className="text-text-secondary">
                El menú superior es tendencia en aplicaciones web modernas y proporciona una mejor experiencia de usuario.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-card p-6">
              <h3 className="text-xl font-semibold text-text-primary mb-2">Mismo Estilo</h3>
              <p className="text-text-secondary">
                Se mantiene la identidad visual con los mismos colores y efectos del menú lateral original.
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TopNavDemo;
